
<div class="modal-header">
    <span class="modal-header-title">{{ 'LOADING_FILES' | translate }}</span>
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.close(result)">
        <span aria-hidden="true">&times;</span>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <div class="file-list">
        <div class="file-list-row" *ngFor="let file of files">

            <div class="col-box">

                <div class="file-list-col file-name">
                    <!-- <img class="file-icon" src="/assets/images/file_icons/png/{{ checkIconExt(file.data.name) }}.png"> -->
                    <svg-icon class="" src="/assets/images/icons/upload-file.svg" [stretch]="true"
                    [svgStyle]="{'width.px':35, 'height.px':35}"></svg-icon>
                    <span class="file-name-text"> {{ file.data.name.length > 50 ? getModifyName(file.data.name) : file.data.name}} </span>
                </div>
                <div class="file-list-col size-of-uploaded-file">
                    {{ calculationOfLoadedVolume(file.data.size, file.progress) }} MB <span class="sub-text">{{ 'DIALOG.OUT_OF' | translate }} {{ convertationToMb(file.data.size) }} MB</span>
                </div>
                <div class="file-list-col file-status">
                    <div class="success" *ngIf="file.progress == 100 && !file.error">
                        <i class="bi bi-check-circle-fill"></i>
                    </div>
                    <div class="await" *ngIf="file.progress < 100 && !file.error">
                        <i class="bi bi-x-circle-fill"></i>
                    </div>
                    <div class="error" *ngIf="file.error">
                        <i class="bi bi-x-circle-fill"></i>
                    </div>
                </div>
                
            </div>

            <div class="progressbar-active">
                <ngb-progressbar type="warning" [value]="file.progress"></ngb-progressbar>
            </div>

            <div class="progressbar-inactive" *ngIf="!file.inProgress || file.progress == 100"></div>

        </div>
    </div>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-primary btn-sm" (click)="fileField.click()" *ngIf="option.multiple">
        {{ 'DIALOG.LOAD_MORE' | translate }}
        <input 
          #fileField 
          multiple
          type="file"
          class="hide"
          (change)="additionallySelectedFiles($event.target.files)">
    </button>
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.close(result)" [disabled]="!result">{{ 'CLOSE' | translate }}</button>
</div>